<template>
  <el-container
    style="
      display: flex;
      justify-content: center;
      margin: 5vh 5vw;
      max-height: 80vh;
      overflow-y: auto;
      overflow-x: hidden;
    "
  >
    <el-card
      :class="{ active: !isCollapsed, inactive: isCollapsed }"
      style="width: 700px"
      body-style="height: 100%; display: flex; flex-direction: column; justify-content:center; align-items: center; padding: 0"
    >
      <div
        style="width: 60%; display: flex; flex-direction: column; justify-content:center; align-items"
      >
        <div
          style="
            margin-bottom: 10px;
            height: 56px;
            width: 418.8px;
            overflow-y: auto;
            overflow-x: hidden;
          "
        >
          <h1 style="text-align: center">{{ envName }}</h1>
        </div>
        <div
          style="
            margin-bottom: 10px;
            height: 32px;
            width: 418.8px;
            overflow-y: auto;
            overflow-x: hidden;
          "
        >
          <h5 style="text-align: center">
            {{
              envType === "cloud"
                ? `${envAdminHost}.planning-analytics.ibmcloud.com`
                : envAdminHost
            }}
          </h5>
        </div>
        <el-form style="margin: 20px 0">
          <el-form-item>
            <span
              slot="label"
              style="display: flex; justify-content: space-between"
            >
              <span> Planning Analytics Server </span>
              <el-checkbox
                style="margin: 0"
                v-model="isProduction"
                :disabled="userRole === 'Standard' || !selection"
                @change="setServerType"
                >Production</el-checkbox
              >
            </span>
            <el-select
              filterable
              v-model="selection"
              @input="isSelected"
              value-key="serverName"
              placeholder
              style="width: 100%"
            >
              <el-option
                v-for="item in servers"
                :key="item.serverName"
                :label="item.serverName"
                :value="item"
              />
              <el-tooltip
                class="modal-info"
                placement="top"
                effect="light"
                content="Server name is case-sensitive"
              >
                <el-option
                  :value="null"
                  v-if="envType === 'cloud' && userRole === 'Administrator'"
                >
                  <i class="el-icon-plus small" /> Add Server
                </el-option>
              </el-tooltip>
            </el-select>
          </el-form-item>
          <el-collapse
            v-model="dropDownActive"
            @change="() => (isCollapsed = !isCollapsed)"
            v-if="
              envType === 'local' &&
              userRole === 'Administrator' &&
              selection &&
              selection.authenticationMode !== 'Negotiate'
            "
            style="margin-top: 10px"
          >
            <el-collapse-item name="1">
              <template slot="title">
                Administrator Credentials
                <el-tooltip placement="right" effect="light">
                  <span slot="content"
                    >The Planning Analytics server's administrator credentials
                    will<br />be saved for all users who have access to this
                    environment.</span
                  >
                  <i
                    class="el-icon-info"
                    style="position: relative; left: 4px; bottom: 1px"
                  />
                </el-tooltip>
              </template>
              <el-radio-group
                v-model="authenticationMode"
                v-if="
                  selection &&
                  selection.authenticationMode ===
                    'Negotiate, Basic realm=&quot;TM1&quot;'
                "
                :disabled="selection && selection.savedAuthMode !== null"
              >
                <el-radio label='Basic realm="TM1"'
                  >Standard TM1 Authentication</el-radio
                >
                <el-radio label="Negotiate"
                  >Windows Integrated Authentication</el-radio
                >
              </el-radio-group>
              <el-form
                @submit.native.prevent="saveCredentials"
                style="margin-top: 10px"
              >
                <el-input
                  v-if="
                    selection &&
                    selection.authenticationMode &&
                    selection.authenticationMode.includes('CAMNamespace')
                  "
                  placeholder="Namespace"
                  v-model="$v.namespace.$model"
                  :class="{
                    error: checkValid && $v.namespace.$invalid,
                  }"
                  style="margin: 15px 0"
                  :disabled="
                    selection &&
                    selection.namespace &&
                    selection.namespace.length > 0
                  "
                />
                <el-input
                  v-if="authenticationMode !== 'Negotiate'"
                  placeholder="Username"
                  v-model="$v.username.$model"
                  :class="{
                    error: checkValid && $v.username.$invalid,
                  }"
                  style="margin-bottom: 15px"
                  :disabled="
                    selection &&
                    selection.username &&
                    selection.username.length > 0
                  "
                />
                <el-input
                  v-if="authenticationMode !== 'Negotiate'"
                  placeholder="Password"
                  type="password"
                  v-model="password"
                  show-password
                  style="margin-bottom: 15px"
                  :disabled="
                    selection &&
                    selection.username &&
                    selection.username.length > 0
                  "
                />
                <el-button
                  class="button"
                  style="box-sizing: border-box; width: 100%"
                  @click="clearCredentials"
                  v-if="selection && selection.savedAuthMode"
                  >Clear Credentials</el-button
                >
                <el-button
                  class="button"
                  style="box-sizing: border-box; width: 100%"
                  v-else
                  native-type="submit"
                  >Save Credentials</el-button
                >
              </el-form>
            </el-collapse-item>
          </el-collapse>
          <el-button
            class="button"
            @click="login"
            style="width: 100%; margin-top: 40px"
            :disabled="
              !(envType === 'SaaS') &&
              (!selection ||
                (selection &&
                  selection.authenticationMode !== 'Negotiate' &&
                  !selection.savedAuthMode))
            "
            >Connect</el-button
          >
        </el-form>
      </div>
    </el-card>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import ServerService from "../services/ServerService";
import { requiredIf } from "vuelidate/lib/validators";
import Helper from "../utilities/Helper";

/**
 * @vue-data {Array} [servers=[]] - PA servers available at the specified admin host
 * @vue-data {Number} [selection=null] - Selected PA server
 * @vue-data {String} [namespace=""] - Current user's PA namespace
 * @vue-data {String} [username=""] - Current user's PA username
 * @vue-data {String} [password=""] - Current user's PA password
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 * @vue-data {Array} [dropDownActive=[]]
 * @vue-data {Boolean} [isCollapsed=true]
 */
export default {
  data() {
    return {
      servers: [],
      selection: null,
      namespace: null,
      username: null,
      password: null,
      checkValid: false,
      dropDownActive: [],
      isCollapsed: true,
      serverName: null,
      isProduction: false,
      authenticationMode: null,
    };
  },
  computed: {
    ...mapState([
      "environmentId",
      "envName",
      "envAdminHost",
      "isUserLoggedIn",
      "userRole",
      "envType",
    ]),
  },
  methods: {
    handleError: Helper.handleError,
    trim: Helper.trim,
    /**
     * Sets the PA server type
     * @async
     * @function
     */
    async setServerType() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        await ServerService.setServerType({
          environmentId: this.environmentId,
          serverName: this.selection.serverName,
          type: this.isProduction ? "Production" : "Development",
        });

        this.$message({
          type: "success",
          message: `"${this.selection.serverName}" server type saved successfully`,
          duration: 5000,
          showClose: true,
        });
      } catch (err) {
        if (err.response.status === 403) this.isProduction = false;
        this.handleError(err, this, null);
      } finally {
        loading.close();
      }
    },
    /**
     * Clears PA local server credentials
     * @async
     * @function
     */
    async clearCredentials() {
      const input = prompt(
        `Are you sure you want to clear the saved credentials for the "${this.selection.serverName}" Planning Analytics server? This will prohibit users from connecting to this server and will deactivate all scheduled packages. Type the name of the server to confirm.`
      );
      if (input === null) {
        return;
      } else if (
        input.toLowerCase() === this.selection.serverName.toLowerCase()
      ) {
        const loading = this.$loading({
          lock: true,
          //text: "Working",
          background: "rgba(0, 0, 0, 0.3)",
        });
        try {
          await ServerService.clearCredentials({
            environmentId: this.environmentId,
            serverName: this.selection.serverName,
          });

          this.$message({
            type: "success",
            message: `"${this.selection.serverName}" credentials cleared successfully`,
            duration: 5000,
            showClose: true,
          });

          await this.showServers();

          this.selection.namespace = null;
          this.selection.username = null;
          this.selection.password = null;
          this.selection.savedAuthMode = null;
          this.namespace = null;
          this.username = null;
          this.password = null;
        } catch (err) {
          this.handleError(err, this, null);
        } finally {
          loading.close();
        }
      } else {
        this.$message({
          type: "warning",
          message:
            "You must provide valid input to clear the server's credentials.",
          duration: 7000,
          showClose: true,
        });
      }
    },
    /**
     * Saves PA local server credentials
     * @async
     * @function
     */
    async saveCredentials() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.checkValid = true;
        if (this.$v.namespace.$invalid || this.$v.username.$invalid) return;

        await ServerService.saveLocal({
          environmentId: this.environmentId,
          serverName: this.selection.serverName,
          ipAddress: this.selection.ipAddress,
          httpPortNumber: this.selection.httpPortNumber,
          usingSSL: this.selection.usingSSL,
          authenticationMode: this.authenticationMode,
          namespace: this.trim(this.namespace),
          username: this.trim(this.username),
          password: this.trim(this.password),
          type: this.isProduction ? "Production" : "Development",
        });

        this.$message({
          type: "success",
          message: `"${this.selection.serverName}" credentials saved successfully`,
          duration: 5000,
          showClose: true,
        });
        this.isCollapsed = true;
        this.dropDownActive = [];
        this.selection.namespace = this.namespace;
        this.selection.username = this.username;
        this.password = "************";
        this.selection.savedAuthMode = this.authenticationMode;
        this.checkValid = false;
      } catch (err) {
        this.handleError(err, this, null);
      } finally {
        loading.close();
      }
    },
    /**
     * Displays the list of PA servers available at the specified admin host
     * @async
     * @function
     */
    async showServers() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await ServerService.show({
          environmentId: this.environmentId,
        });

        if (this.userRole === "Administrator") {
          this.servers = response.data.servers;
        } else {
          this.servers = response.data.servers.filter(
            (server) => server.username
          );
        }
      } catch (err) {
        this.handleError(err, this, null);
      } finally {
        loading.close();
      }
    },
    /**
     * Updates the selected data variable with the index of the PA server selection
     * @function
     * @param {Number} index - Index of the selection
     */
    async isSelected(server) {
      if (this.envType === "local") {
        this.namespace = server.namespace;
        this.username = server.username;
        this.password = server.password;
      } else {
        if (!server) {
          this.serverName = prompt("Planning Analytics Server Name");
          if (this.serverName === null) return;

          const loading = this.$loading({
            lock: true,
            //text: "Working",
            background: "rgba(0, 0, 0, 0.3)",
          });
          try {
            this.checkValid = true;

            await ServerService.saveCloud({
              environmentId: this.environmentId,
              serverName: this.serverName,
              type: this.isProduction ? "Production" : "Development",
            });

            await this.showServers();

            this.selection = this.servers.find(
              (server) => server.serverName === this.serverName
            );
            this.$message({
              type: "success",
              message: `"${this.serverName}" saved successfully`,
              duration: 5000,
              showClose: true,
            });
            this.checkValid = false;
          } catch (err) {
            this.handleError(err, this, null);
          } finally {
            loading.close();
          }
        }
      }
      if (this.selection) {
        this.isProduction = this.selection.type === "Production";
        this.authenticationMode =
          this.selection.authenticationMode === 'Negotiate, Basic realm="TM1"'
            ? this.selection.savedAuthMode
              ? this.selection.savedAuthMode
              : 'Basic realm="TM1"'
            : this.selection.authenticationMode;
      }
    },
    /**
     * Logs in to a PA server
     * @function
     */
    async login() {
      if (!this.selection) {
        this.$message({
          type: "warning",
          message:
            "Select one of the available Planning Analytics servers to connect.",
          duration: 7000,
          showClose: true,
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        if (this.envType === "local") this.checkValid = true;

        if (this.selection.authenticationMode === "Negotiate")
          await ServerService.saveLocal({
            environmentId: this.environmentId,
            serverName: this.selection.serverName,
            ipAddress: this.selection.ipAddress,
            httpPortNumber: this.selection.httpPortNumber,
            usingSSL: this.selection.usingSSL,
            authenticationMode: this.authenticationMode,
            type: this.isProduction ? "Production" : "Development",
          });

        if (this.envType === "SaaS") {
          await ServerService.saveLocal({
            environmentId: this.environmentId,
            serverName: this.selection.serverName,
            ipAddress: this.selection.ipAddress,
            httpPortNumber: 5000,
            usingSSL: true,
            authenticationMode: "SaaS",
            type: this.isProduction ? "Production" : "Development",
          });
        }

        const response = await ServerService.login({
          environmentId: this.environmentId,
          serverName: this.selection.serverName,
        });

        const { instanceId } = response.data;
        this.$store.dispatch("setInstanceId", instanceId);
        this.$store.dispatch("setCurrentServer", this.selection.serverName);
        this.$router.push({ name: "tasks", params: { instanceId } });
      } catch (err) {
        this.handleError(err, this, null);
      } finally {
        loading.close();
      }
    },
  },
  async mounted() {
    if (!this.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    } else if (!this.environmentId) {
      this.$router.push({ name: "environments" });
    } else {
      await this.showServers();
      if (this.$route.params.server) {
        this.selection = this.$route.params.server;
      } else {
        this.selection = this.servers[0];
      }
      this.authenticationMode = this.selection.savedAuthMode
        ? this.selection.savedAuthMode
        : this.selection.authenticationMode === 'Negotiate, Basic realm="TM1"'
        ? 'Basic realm="TM1"'
        : this.selection.authenticationMode;
      if (this.envType === "local") {
        this.namespace = this.selection.namespace;
        this.username = this.selection.username;
        this.password = this.selection.password;
      }
      if (this.selection) {
        this.isProduction = this.selection.type === "Production";
      }
      if (this.isUserLoggedIn) {
        this.$message({
          type: "info",
          message:
            "Choose which Planning Analytics server you want to work with.",
          duration: 5000,
          showClose: true,
        });
      }
    }
  },
  validations() {
    return {
      namespace: {
        required: requiredIf(() => {
          return (
            this.envType === "local" &&
            this.selection.authenticationMode.includes("CAMNamespace")
          );
        }),
      },
      username: {
        required: requiredIf(() => {
          return (
            this.envType === "local" &&
            (this.authenticationMode === 'Basic realm="TM1"' ||
              this.selection.authenticationMode.includes("CAMNamespace"))
          );
        }),
      },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.active {
  height: 720px;
}
.inactive {
  height: 529px;
}
.el-form-item :deep(.el-form-item__label) {
  width: 100%;
  padding: 0;
}
</style>
